<template>
    <properties-block  v-bind="$props" v-on="$listeners">
        <properties-component-image title="Image" :value="block.image" v-bind="componentProps"/>
        <properties-component-glyph title="Glyph|Icône" :value="block.glyph" v-bind="componentProps"/>
        <properties-component-text title="Title|Titre" :value="block.title" v-bind="componentProps"/>
        <properties-component-text title="Subtitle|Sous-Titre" :value="block.subtitle" v-bind="componentProps"/>
        <properties-component-text title="Description" :value="block.description" v-bind="componentProps"/>
        <properties-component-button title="Button|Bouton" :value="block.button" v-bind="componentProps"/>
        <properties-component-button title="Alt Button|2e bouton" :value="block.altButton" v-bind="componentProps"/>

        <template #layout>
            <b-form-group label-cols="0" class="flex" v-if="block?.mediaProxy?.layout?.startsWith('row')">
                <b-row>
                    <b-col md="7">
                        <b-input v-model.number="block.mediaProxy.span" :min="1" :max="11" step="1" type="range" class="e-slider"/>
                    </b-col>
                    <b-col md="5">
                        <small class="text-muted">{{ block.mediaProxy.span }} / {{ 12 - block.mediaProxy.span }} columns</small>
                    </b-col>
                </b-row>
            </b-form-group>
        </template>
    </properties-block>
</template>

<script>
import PropertiesComponentButton from "@/components/editor/properties/components/properties-component-button.vue";
import PropertiesComponentImage from "@/components/editor/properties/components/properties-component-image.vue";
import PropertiesComponentText from "@/components/editor/properties/components/properties-component-text.vue";
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";
import PropertiesComponentGlyph from "@components/editor/properties/components/properties-component-glyph.vue";

// properties-block-text-and-image #hot-reload-debug
export default {
    name: `properties-block-text-and-image`,
    components: {PropertiesComponentGlyph, PropertiesComponentImage, PropertiesComponentButton, PropertiesComponentText, PropertiesBlock},
    extends: PropertiesBlock,
}
</script>

<style lang="scss" scoped>
.e-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 10px;
    background-color: var(--primary);
    overflow: visible;
    cursor: pointer;
    border: var(--border-width) solid white;
}
</style>
